import { withRouter } from 'react-router';
import { useHistory } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import '../../../../Utility/Public/css/theme.css';
import PropTypes from 'prop-types';
import moment from 'moment';


const FollowupPanel = (props) => {
	const messageRef = useRef();
	useEffect(() => {
		if (messageRef.current) {
			messageRef.current.scrollIntoView(
				{
					behavior: 'smooth',
					block: 'end',
					inline: 'nearest'
				})
		}
	})

	const followUpUi = () => {
		let arry = [];

		if (props.chatHistoryData.length > 0) {

			props.chatHistoryData.map((item, index) => {
				let docLink = item.doc_link ? JSON.parse(item.doc_link) : {};

				arry.push(
					<li key={index}>
						<div className='paraBox'>
							<p>{item.chat_text}</p>
							{item.doc_link != null && item.doc_link != "" ?
								<button type="button" className="downloadiconbtn downloadbtn"  >

									<a href={docLink?.doc_url} target="_blank" className='pdfIcon'>

										<i className="fa fa-file-pdf-o" aria-hidden="true"></i>

									</a>

								</button> : null}
							<span>
								{moment(item.chat_date).format('MMMM Do YYYY, h:mm:ss a')}
								<br />
								Followed up by : {item?.UserDetails?.first_name} {item?.UserDetails?.last_name}
							</span>


						</div>
					</li>
				);
			})
		}


		return arry;

	}
	return (
		<div className='chatPanelBoxes'>
			<div className='chapBox'>
				<ul ref={messageRef}>
					{followUpUi()}


				</ul>

			</div>
		</div>
	);
}




const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials,
		token: globalState.LoginReducer.token
	};
}


export default withRouter(connect(mapStateToProps)
	(FollowupPanel));



